var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CInfoPageTemplate,{attrs:{"content-label":'预约须知',"content-text":_setup.moduleOptions.notice,"button-text":'立即预约'},on:{"button-click":_setup.goAppointment}})
}
var staticRenderFns = []

export { render, staticRenderFns }